// components/MessageItem.tsx
import React, { useEffect, useRef, useState } from 'react';
import userIcon from '../profile.svg'; // or public/user-icon.png
import botIcon from '../profile.svg';   // or public/bot-icon.png
import ReactMarkdown from 'react-markdown';
import Modal from './ui/Modal';

type Props = {
  data: string;
  sender: 'user' | 'bot';
  msgId: string;
  citations?: {
    chunkId: string;
    filename: string;
    contents: string;
    messageId?: string | null; // Optional, can be null if not set
  }[];
};

const MessageItem = ({ data, sender, msgId, citations }: Props) => {
  const isUser = sender === 'user';
  const hasCitations = citations && citations.length > 0;
  const avatar = isUser ? userIcon : botIcon;
  const ref = useRef<HTMLDivElement>(null);
  const [activeId, setActiveId] = useState<string | null>(null)

  const [showModal, setShowModal]     = useState(false)
  const [modalBody, setModalBody]     = useState<React.ReactNode>(null)
  const [modalTitle, setModalTitle]   = useState('')

  useEffect(() => {
    if (ref.current) {
      ref.current.style.opacity = '0';
      requestAnimationFrame(() => {
        ref.current!.style.transition = 'opacity 0.3s ease-in';
        ref.current!.style.opacity = '1';
      });
    }
  }, []);

  const showCitation = (citation: any) => {
    setModalTitle(citation.filename);
    setModalBody(
      <div className="flex flex-col space-y-2">
        <div key={citation.chunkId} className="p-4 bg-gray-100 rounded text-sm">
            <ReactMarkdown>{citation.contents}</ReactMarkdown>
        </div>
      </div>
    );
    setShowModal(true);
  }
  return (
    <div 
      className={`message-row w-full ${isUser ? 'user' : 'bot'} flex items-start relative group outline-none`} 
      onMouseEnter={() => hasCitations ? setActiveId(msgId) : null}
      onMouseLeave={() => setActiveId(null)}  
      onClick={() => hasCitations ? setActiveId(msgId) : null}
      ref={ref}
      tabIndex={0} 
    >
      <div className="message-bubble" >
        <ReactMarkdown>{data}</ReactMarkdown>
      </div>

      {/* Sticky right-side action panel */}
      {activeId === msgId && (
        <div className="sticky-box ml-2 top-2 z-10">
          <div className="flex flex-col space-y-1 bg-blue-100 p-1 rounded w-[50px]">
            {(citations ?? []).map((citation, index) => (
              <button
                key={citation.chunkId}
                className="bg-blue-500 text-white rounded h-8 hover:bg-blue-600"
                onClick={(e) => {
                  e.stopPropagation()
                  showCitation(citation)
                }}
                
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>
      )}

      <Modal
        isOpen={showModal}
        title={modalTitle}
        onClose={() => setShowModal(false)}
        body={modalBody}
        classStyles='max-w-screen-2xl h-2/3'
      />
    </div>
  );
};

export default MessageItem;
